/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_VerdictInputs */

const en_pc_cmp_verdict = /** @type {(inputs: Pc_Cmp_VerdictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If most of your PDF work is reading, marking up, filling forms and moving pages, PdfCraft does it well for free, so try it before you renew. If you rely on text editing, Office conversion or signatures, keep Acrobat for now and watch the PdfCraft roadmap.`)
};

const zh_pc_cmp_verdict = /** @type {(inputs: Pc_Cmp_VerdictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果你的 PDF 工作主要是阅读、标注、填表和调整页面，PdfCraft 能免费做好这些，续订前不妨先试试。如果你依赖文字编辑、Office 转换或签名，暂时继续使用 Acrobat，并关注 PdfCraft 的路线图。`)
};

/**
* | output |
* | --- |
* | "If most of your PDF work is reading, marking up, filling forms and moving pages, PdfCraft does it well for free, so try it before you renew. If you rely on t..." |
*
* @param {Pc_Cmp_VerdictInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_verdict = /** @type {((inputs?: Pc_Cmp_VerdictInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_VerdictInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_verdict(inputs)
	return zh_pc_cmp_verdict(inputs)
});
export { pc_cmp_verdict as "pc.cmp.verdict" }